import React from 'react';
import "./EppMessagesType.css"
import _ from "lodash"
import BaseMessage from "./BaseMessage";

const WrongNamespaceReminderMessage = (props) => {

    function Detail({data}) {
        if (data) {
            return (
                <div className={'typedLayout-container'}>
                    {data &&
                    <div>
                        <div className={'typedLayout-data'}>
                            {data['wrongNamespaces'] &&
                            <div className={'typedLayout-row'}>
                                <span className={'label'}>Namespaces errati:</span>
                                <span className={'content'}>
                                    <ul className={'unstyled-list'}>{
                                        _.values(data['wrongNamespaces']).map(function (value) {
                                                return <li>{value}</li>
                                            }
                                        )
                                    }</ul>
                                </span>
                            </div>
                            }


                        </div>
                    </div>}
                </div>
            )
        }
        else {
            return <span/>
        }
    }

    return (
        <BaseMessage
            detail={props.detail}
            component={<Detail data={props.detail.data}/>}
        />
    );
};

WrongNamespaceReminderMessage.propTypes = {};
WrongNamespaceReminderMessage.defaultProps = {};

export default WrongNamespaceReminderMessage;
